import React, { useRef, useState } from 'react';
import SideNav, { Toggle, Nav, NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '../Pages/Css/react-sidenav.css';
import CryptoJS from 'crypto-js';
import axios from '../utils/axiosConfig';
import Swal from 'sweetalert2';
import { descargarReporteGeneral } from '../utils/descargarReporteGeneral';
import { useAuth } from '../auth/AuthContext';

// Modales / páginas
import ModalReporteServicio from '../components/modals/modalReporteServicio';
import ModalReporteConsolidadoAjustado from '../components/modals/modalReporteConsolidadoAjustado';
import FormStaticsMapsRecorrido from '../components/formsSolicitudes/formStaticsMapsRecorrido';
import ReporteServicio from './Reporteservicio';
import ModalBaseSm from '../components/modals/modal-base-sm';
import ModalBaseLg from '../components/modals/modal-base-lg';
import FormReporteVentas from '../components/menuContratos/FormReporteVentas';
import Valitronics from '../Pages/Valitronics';
import CrearContrato2 from '../Pages/CrearContrato2';
import CrearContrato3 from '../Pages/CrearContrato3';
import FormStaticsMapsContrato from '../components/formsSolicitudes/FormStaticsMapsContrato';
import CambioProyecto from '../components/modals/cambioProyecto';
import BaseModalXXL from '../components/modals/baseModalXXL';
import MapCenter from './MapCenter';
import ModalTransportadoras from '../components/maestros/modals/modalTransportadora';
import RSeguimientoServicio from '../components/modals/modalRSeguimientoServicio';
import ModalInstaladores from '../components/maestros/modals/modalInstaladores';
import ModalRutas from '../components/maestros/modals/modalRutas';
import ModalAcompanantes from '../components/maestros/modals/modalAcompanantes';
import ModalCreatePlantilla from '../components/modals/modalCreatePlantilla';
import BuscarContratoYReporte from '../components/multipleReporteDowload/BuscarContratoYReporte';
import ModalAdminGrupos from '../components/maestros/modals/modalAdminGrupos';
import ModalAlertas from '../components/maestros/modals/modalAlertas';
import ModalCiudades from '../components/maestros/modals/modalCiudades';
import ModalPropietarios from '../components/maestros/modals/modalPropietarios';
import ModalAgencias from '../components/maestros/modals/modalAgencias';
import ModalVehiculos from '../components/maestros/modals/modalVehiculos';
import ModalReportesBI from '../components/modals/reporteBI/modalReportesBI';
import ModalDispositivos from '../components/maestros/modals/modalDispositivos';
import ModalUsuariosStreaming from '../components/maestros/modals/modalUsuariosStreaming';
import ModalCorreccionFechas from '../components/modals/modalCorreccionFechas';
import ModalModificaciones from '../components/modals/modalModificaciones';
import ModalCorreccionSolicitud from '../components/modals/modalCorreccionSolicitud';
import ModalTrackingTiempoReal from '../components/modals/modalTrackingTiempoReal';
import ReporteContrato from './ReporteContrato';
import ModalMultimediaHub, { multimediaHubTabs } from '../components/modals/menuContratos/modalMultimediaHub';
import ModalComprobanteValitronics from '../components/modals/menuContratos/modalComprobanteValitronics';
import PrintComponent from '../components/printComponent/PrintComponent';
import FormReporteServicio from '../components/formsSolicitudes/formReporteServicio';
import BaseModalAuto from '../components/modals/baseModalAuto';
import ModalAsignacion from '../components/modals/menuContratos/modalAsignacion';
import ModalBeacons from '../components/maestros/modals/modalBeacons';

const NEW_TAB_KEYS = new Set([
    'solicitudes', // siempre nueva pestaña
    'mapcenter', // siempre nueva pestaña
    'geocercas2', // siempre nueva pestaña
    'control', // siempre nueva pestaña
    'reportes', // siempre nueva pestaña
    'trayecto', // siempre nueva pestaña
    'configLives', // siempre nueva pestaña
    // agrega más claves aquí si las quieres forzar en _blank
]);

const normalizeTrackingContract = (info, fallbackContract) => {
    if (!info) return null;

    const startDate =
        info.fechainicio ||
        info.fecha ||
        info.FechaHoraInicio ||
        info.InicioServicio ||
        '';

    return {
        ...info,
        ContractID: info.ContractID || info.ContratoID || fallbackContract,
        FKLokDeviceID: info.FKLokDeviceID || info.DeviceID || info.Device || '',
        fechainicio: startDate,
        fecha: startDate,
        fechafin: info.fechafin || info.FechaHoraFin || info.FinalServicio || '',
        NombreEmpresa: info.NombreEmpresa || info.Empresa || 'Sin informacion',
        DescripcionRuta: info.DescripcionRuta || info.Ruta || 'Sin informacion',
        trayecto: info.trayecto ?? info.FKTrayecto ?? 0,
        Active: info.Active ?? info.Activo ?? true,
        FKLokTipoEquipo: info.FKLokTipoEquipo ?? info.TipoEquipo ?? 0,
        Locked: info.Locked ?? info.Bloqueado ?? 1,
        Origen: info.Origen || '',
        DistanciaCompleta: info.DistanciaCompleta ?? 0,
    };
};

const getMissingTrackingFields = (trackingInfo) => {
    const requiredFields = [
        { key: 'ContractID', label: 'ContractID' },
        { key: 'FKLokDeviceID', label: 'FKLokDeviceID' },
        { key: 'fechainicio', label: 'fechainicio' },
        { key: 'fechafin', label: 'fechafin' },
    ];

    return requiredFields
        .filter(({ key }) => {
            const value = trackingInfo?.[key];
            return value === undefined || value === null || String(value).trim() === '';
        })
        .map(({ label }) => label);
};

const Menu = () => {
    const { accessToken } = useAuth();
    const reporteGeneralEnCurso = useRef(false);

    const handleDescargarReporteGeneral = async () => {
        if (reporteGeneralEnCurso.current) return;
        reporteGeneralEnCurso.current = true;
        Swal.fire({
            title: 'Descargando archivo',
            text: 'Se está descargando el archivo. Por favor, espere…',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => Swal.showLoading(),
        });

        try {
            await descargarReporteGeneral(accessToken);
            Swal.close();
        } catch (error) {
            Swal.fire({
                title: 'Reporte general',
                text: error.isAxiosError
                    ? 'No se pudo descargar el reporte general. Intente nuevamente más tarde.'
                    : error.message,
                icon: 'error',
                confirmButtonText: 'Aceptar',
            });
        } finally {
            reporteGeneralEnCurso.current = false;
        }
    };

    const [isDialogOpenRServicioAjustado, setIsDialogOpenRServicioAjustado] = useState(false);
    const [isDialogOpenModalReporteServicio, setIsDialogOpenModalReporteServicio] = useState(false);
    const [isDialogOpenModalTransportadora, setIsDialogOpenModalTransportadora] = useState(false);
    const [isDialogOpenModalInstaladores, setIsDialogOpenModalInstaladores] = useState(false);
    const [isDialogOpenModalRutas, setIsDialogOpenModalRutas] = useState(false);
    const [isDialogOpenModalDispositivos, setIsDialogOpenModalDispositivos] = useState(false);
    const [isDialogOpenModalBeacons, setIsDialogOpenModalBeacons] = useState(false);
    const [isDialogOpenCiudades, setIsDialogOpenCiudades] = useState(false);
    const [isDialogOpenModalAcompanantes, setIsDialogOpenModalAcompanantes] = useState(false);
    const [isDialogOpenModalAdminGrupos, setIsDialogOpenModalAdminGrupos] = useState(false);
    const [isDialogOpenModalAlertas, setIsDialogOpenModalAlertas] = useState(false);
    const [isDialogOpenModalAgencias, setIsDialogOpenModalAgencias] = useState(false);
    const [isDialogOpenModalPropietarios, setIsDialogOpenModalPropietarios] = useState(false);
    const [isDialogOpenModalVehiculos, setIsDialogOpenModalVehiculos] = useState(false);
    const [isDialogOpenModalUsuariosStreaming, setIsDialogOpenModalUsuariosStreaming] = useState(false);
    const [isDialogOpenCorreccionFechas, setIsDialogOpenCorreccionFechas] = useState(false);
    const [correccionFechasModalSize, setCorreccionFechasModalSize] = useState('sm');
    const [isDialogOpenModificaciones, setIsDialogOpenModificaciones] = useState(false);
    const [isDialogOpenCorreccionSolicitud, setIsDialogOpenCorreccionSolicitud] = useState(false);
    const [isDialogOpenTrackingTiempoReal, setIsDialogOpenTrackingTiempoReal] = useState(false);
    const [isDialogOpenTrackingTiempoRealViewer, setIsDialogOpenTrackingTiempoRealViewer] = useState(false);
    const [trackingTiempoRealInfo, setTrackingTiempoRealInfo] = useState(null);
    const [trackingDataGlobal, setTrackingDataGlobal] = useState(null);
    const [trackingInfoContratoContainer, setTrackingInfoContratoContainer] = useState('');
    const [trackingSelectedContractID, setTrackingSelectedContractID] = useState(-1);
    const [trackingMultimediaHubTab, setTrackingMultimediaHubTab] = useState(multimediaHubTabs.PHOTOS);
    const [isDialogOpenTrackingMultimedia, setIsDialogOpenTrackingMultimedia] = useState(false);
    const [isDialogOpenTrackingValitronics, setIsDialogOpenTrackingValitronics] = useState(false);
    const [isDialogOpenTrackingCheckList, setIsDialogOpenTrackingCheckList] = useState(false);
    const [isDialogOpenTrackingMonitoreo, setIsDialogOpenTrackingMonitoreo] = useState(false);
    const [isDialogOpenTrackingAsignacion, setIsDialogOpenTrackingAsignacion] = useState(false);
    const [trackingListComprobantes, setTrackingListComprobantes] = useState([]);
    const [trackingListRutas, setTrackingListRutas] = useState([]);
    const [trackingRutaSeleccionada, setTrackingRutaSeleccionada] = useState(-1);

    const [ultPunto, setUltPunto] = useState(-1);
    const [contractR, setContractR] = useState(-1);
    const [infoContrato, setInfoContrato] = useState({});
    const [modalOpenGenerarContrato, setModalOpenGerarContrato] = useState(false);
    const [modalCambioProyecto, setModalCambioProyecto] = useState(false);
    const [modalMapCenter, setModalOpenMapCenter] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [modalOpenUploadFiles, setModalOpenUploadFiles] = useState(false);
    const [modalDowloadMultipleFiles, setModalDowloadMultipleFiles] = useState(false);
    const [modalTransportadoras, setModalTransportadoras] = useState(false);
    const [modalAdminGrupos, setModalAdminGrupos] = useState(false);
    const [modalReportesBI, setModalReportesBI] = useState(false);
    const [modalReporteVentas, setModalReporteVentas] = useState(false);
    const [isReporteVentasExpanded, setIsReporteVentasExpanded] = useState(false);
    const [reporteVentasSession, setReporteVentasSession] = useState(0);

    const [bitOpen, setBitOpen] = useState(false);
    const [bitInsert, setBitInsert] = useState(false);
    const [bitEdit, setBitEdit] = useState(false);
    const [bitDelete, setBitDelete] = useState(false);

    const [modalvalitronics, setModalValitronics] = useState(false);
    const [modaldispositivos, setModalDispositivos] = useState(false);

    const project = localStorage.getItem('project'); // puede venir como string

    // ---------- helpers ----------
    const navigate = (path, newTab = false) => {
        if (newTab) window.open(path, '_blank', 'noopener,noreferrer');
        else window.location = path;
    };

    const deny = () => {
        Swal.fire({
            title: 'Información',
            text: 'No tiene los permisos necesarios para acceder a esta página',
            icon: 'info',
            showConfirmButton: false,
            timer: 3000,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });
    };

    const checkPerm = async (role, onAllowed) => {
        console.warn("Checking permission for role:", role);
        try {
            const res = await axios.post(
                process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
                JSON.stringify({ pagina: role }),
                {
                    headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("tkn")}` },
                    withCredentials: true,
                }
            );
            if (res.data.success === false) {
                Swal.fire({
                    title: 'Error',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'ok',
                });
                return;
            }
            const bits = res.data.data?.[0];
            if (bits) {
                setBitOpen(bits.bitOpen);
                setBitInsert(bits.bitInsert);
                setBitEdit(bits.bitEdit);
                setBitDelete(bits.bitDelete);
            }
            if (bits?.bitOpen) await onAllowed();
            else deny();
        } catch (error) {
            console.error("Error al listar bit permisos:", error);
        }
    };

    async function encrypt(user, token) {
        const key = CryptoJS.enc.Utf8.parse(token);
        const hmac = CryptoJS.HmacSHA256(user, key);
        return hmac.toString(CryptoJS.enc.Base64);
    }

    const GetKeyApp = async (proj) => {
        try {
            const response = await axios.get(process.env.REACT_APP_SERVER + '/operaciones/getkeyapp', {
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
                withCredentials: true
            });
            if (response.data.success === true) {
                redirectToAuthPage(response.data.user, response.data.data[0].KEYWS, proj);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const redirectToAuthPage = async (user, key, proj) => {
        const go = async (role) => {
            await checkPerm(role, async () => {
                const encryptedToken = await encrypt(user, key);
                const url = `https://mapcenter.cargotronics.com/${proj}/Autenticacion.jsp?user=${user}&token=${encryptedToken}`;
                window.open(url, '_blank', 'noopener,noreferrer'); // externo siempre nueva pestaña
            });
        };
        if (proj === 'WL2') return go('5');
        if (proj === 'Geocerca') return go('7');
        if (proj === 'Inventario') return go('9');
    };

    const handleContrato = (value) => {
        console.log("Contrato seleccionado:", value);
        axios.post(
            process.env.REACT_APP_SERVER + "/operaciones/getcontratounico",
            JSON.stringify({ contrato: value }),
            {
                headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("tkn")}` },
                withCredentials: true,
            }
        ).then((res) => {
            if (res.data.success == false) {
                console.error("Error al obtener el contrato:", res.data.message);
            } else {
                setInfoContrato(res.data.data);
            }
        });
    };


    const onCloseModalCiudades = () => setIsDialogOpenCiudades(false);
    const onCloseModalVehiculos = () => setIsDialogOpenModalVehiculos(false);
    const onCloseModalAgencias = () => setIsDialogOpenModalAgencias(false);
    const onCloseModalPropietarios = () => setIsDialogOpenModalPropietarios(false);
    const onCloseModalAlertas = () => setIsDialogOpenModalAlertas(false);
    const onCloseModalAdminGrupos = () => setIsDialogOpenModalAdminGrupos(false);
    const onCloseModalUploadFiles = () => setModalOpenUploadFiles(false);
    const onCloseReporteServicioAjustado = () => setIsDialogOpenRServicioAjustado(false);
    const onCLoseModalCambioProyecto = () => setModalCambioProyecto(false);
    const onCLoseModalOpenGnenerarContrato = () => setModalOpenGerarContrato(false);
    const onCloseModalTransportadora = () => setIsDialogOpenModalTransportadora(false);
    const onCloseModalInstaladores = () => setIsDialogOpenModalInstaladores(false);
    const onCloseModalRutas = () => setIsDialogOpenModalRutas(false);
    const onCloseModalAcompanantes = () => setIsDialogOpenModalAcompanantes(false);
    const onCloseModalReporteServicio = () => { setIsDialogOpenModalReporteServicio(false); setUltPunto(-1); setContractR(-1); };
    const onCloseTrackingTiempoReal = () => setIsDialogOpenTrackingTiempoReal(false);
    const onCloseTrackingTiempoRealViewer = () => {
        setIsDialogOpenTrackingTiempoRealViewer(false);
        setTrackingTiempoRealInfo(null);
        setTrackingDataGlobal(null);
        setTrackingInfoContratoContainer('');
        setTrackingSelectedContractID(-1);
        setTrackingRutaSeleccionada(-1);
        setIsDialogOpenTrackingMultimedia(false);
        setIsDialogOpenTrackingValitronics(false);
        setIsDialogOpenTrackingCheckList(false);
        setIsDialogOpenTrackingMonitoreo(false);
        setIsDialogOpenTrackingAsignacion(false);
        setTrackingMultimediaHubTab(multimediaHubTabs.PHOTOS);
        setTrackingListComprobantes([]);
    };
    const cerrarModalMapCenter = () => { setModalOpenMapCenter(false); setModalLoading(false); };
    const onCloseModalValitronics = () => setModalValitronics(false);
    const onCloseModalDispositivos = () => setModalDispositivos(false);
    const onCloseModalMaestrosDispositivos = () => setIsDialogOpenModalDispositivos(false);
    const onCloseModalMaestrosBeacons = () => setIsDialogOpenModalBeacons(false);
    const onCloseModalUsuariosStreaming = () => setIsDialogOpenModalUsuariosStreaming(false);
    const handleUltPunto = (v) => setUltPunto(v);
    const handleUltRecorrido = (v) => setContractR(v);
    const handleSubmitAndOpenReporteAjustado = () => {
        if (infoContrato) {
            setIsDialogOpenRServicioAjustado(false);
            setIsDialogOpenModalReporteServicio(true);
        }
    };

    // ========= LÓGICA CENTRAL =========
    const setTrackingContext = (contrato) => {
        if (!contrato) return;
        setTrackingTiempoRealInfo(contrato);
        setTrackingDataGlobal(contrato);
        setTrackingSelectedContractID(contrato?.ContractID || -1);
        setTrackingInfoContratoContainer(contrato?.ContainerNum || '');
        setTrackingRutaSeleccionada(contrato?.trayecto ?? -1);
    };

    const listarComprobantesTracking = async (contrato) => {
        const json = JSON.stringify({ contrato });
        const res = await axios.post(
            process.env.REACT_APP_SERVER + '/operaciones/getcomprobantevalitronics',
            json,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                },
                withCredentials: true,
            }
        );

        if (res.data?.success === false) {
            throw new Error(res.data?.message || 'No se pudieron obtener los comprobantes.');
        }

        setTrackingListComprobantes(res.data?.data || []);
    };

    const listarRutasTracking = async () => {
        const res = await axios.get(
            process.env.REACT_APP_SERVER + '/operaciones/gettrayectoslist',
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                },
                withCredentials: true,
            }
        );

        if (res.data?.success === false) {
            throw new Error(res.data?.message || 'No se pudieron obtener los trayectos.');
        }

        setTrackingListRutas(res.data?.data || []);
    };

    const openTrackingMultimediaHub = (contrato, tab = multimediaHubTabs.PHOTOS) => {
        setTrackingContext(contrato);
        setTrackingMultimediaHubTab(tab);
        setIsDialogOpenTrackingMultimedia(true);
    };

    const openTrackingImages = () => {
        if (!trackingDataGlobal) return;
        openTrackingMultimediaHub(trackingDataGlobal, multimediaHubTabs.PHOTOS);
    };

    const openTrackingVideos = () => {
        if (!trackingDataGlobal) return;
        openTrackingMultimediaHub(trackingDataGlobal, multimediaHubTabs.VIDEOS);
    };

    const openTrackingStreaming = () => {
        if (!trackingDataGlobal) return;
        openTrackingMultimediaHub(trackingDataGlobal, multimediaHubTabs.STREAMING);
    };

    const openTrackingValitronics = async () => {
        if (!trackingDataGlobal?.ContractID) return;
        await listarComprobantesTracking(trackingDataGlobal.ContractID);
        setIsDialogOpenTrackingValitronics(true);
    };

    const openTrackingCheckList = () => {
        if (!trackingDataGlobal) return;
        setIsDialogOpenTrackingCheckList(true);
    };

    const openTrackingMonitoreo = async () => {
        if (!trackingDataGlobal?.ContractID) return;
        await checkPerm('14', async () => {
            setTrackingContext(trackingDataGlobal);
            setIsDialogOpenTrackingMonitoreo(true);
        });
    };

    const openTrackingConsolidado = () => {
        if (!trackingDataGlobal) return;
        setInfoContrato([trackingDataGlobal]);
        setUltPunto(-1);
        setContractR(-1);
        setIsDialogOpenModalReporteServicio(true);
    };

    const openTrackingAsignacion = async () => {
        if (!trackingDataGlobal?.ContractID) return;
        await checkPerm('18', async () => {
            if (!trackingListRutas.length) {
                await listarRutasTracking();
            }
            setTrackingRutaSeleccionada(trackingDataGlobal?.trayecto ?? -1);
            setIsDialogOpenTrackingAsignacion(true);
        });
    };

    const handleTrackingAsignacionClose = () => {
        setIsDialogOpenTrackingAsignacion(false);
    };

    const handleTrackingAsignacionUpdate = (rutaId) => {
        const normalizedRoute = Number(rutaId);
        setTrackingRutaSeleccionada(normalizedRoute);
        setTrackingTiempoRealInfo((current) => current ? { ...current, trayecto: normalizedRoute } : current);
        setTrackingDataGlobal((current) => current ? { ...current, trayecto: normalizedRoute } : current);
        setIsDialogOpenTrackingAsignacion(false);
    };

    const openTrackingTiempoRealByContract = async (contractNumber) => {
        const normalizedContract = String(contractNumber || '').trim().toUpperCase();

        if (!normalizedContract) {
            throw new Error('Ingrese el contrato que desea consultar.');
        }

        let trackingInfo = null;

        await checkPerm('13', async () => {
            const response = await axios.post(
                `${process.env.REACT_APP_SERVER}/contratos/getinfocontrato`,
                { contrato: normalizedContract }
            );

            if (response.data?.success === false) {
                throw new Error(response.data?.message || response.data?.mensaje || 'No fue posible consultar el contrato.');
            }

            const rawInfo = Array.isArray(response.data?.data) ? response.data.data[0] : response.data?.data;
            if (!rawInfo) {
                throw new Error('No se encontro informacion para el contrato ingresado.');
            }

            trackingInfo = normalizeTrackingContract(rawInfo, normalizedContract);
            const missingFields = getMissingTrackingFields(trackingInfo);

            if (missingFields.length > 0) {
                throw new Error(`Faltan campos para abrir el tracking en tiempo real: ${missingFields.join(', ')}.`);
            }
        });

        if (!trackingInfo) {
            return;
        }

        setTrackingContext(trackingInfo);
        setIsDialogOpenTrackingTiempoReal(false);
        setIsDialogOpenTrackingTiempoRealViewer(true);
    };

    const openByKey = async (selected, newTab = false) => {
        // ----- OPERACIONES -----
        if (selected === "trafico") return navigate('/trafico', newTab);
        if (selected === "traficoPorRecoger") {
            return checkPerm('65', async () => navigate('/trafico_por_recoger', newTab));
        }
        if (selected === "trayecto") return navigate('/trayecto', newTab);
        if (selected === "historico") return navigate('/historico', newTab);

        if (selected === "ediciontrakaphotos") {
            return checkPerm('27', async () => navigate('/ediciontrakaphoto', newTab));
        }

        if (selected === "reportes") {
            return checkPerm('10', async () => navigate('/reportes'));
        }

        if (selected === "reporteGeneral") {
            return checkPerm('61', handleDescargarReporteGeneral);
        }

        if (selected === "reporteVentas") {
            return setModalReporteVentas(true);
        }

        if (selected === "roles") return navigate('/roles', newTab);
        if (selected === "usuarios") return navigate('/usuarios', newTab);
        if (selected === "configLives") return navigate('/lives_config', newTab);

        if (selected === "mapcenter2") return GetKeyApp("WL2");
        if (selected === "mapcenter") return navigate('/mapCenter', newTab);
        if (selected === "geocercas2") return navigate('/geocercas2', newTab);
        if (selected === "control") return navigate('/controldevices', newTab);
        if (selected === "solicitudes") return navigate('/solicitudes', newTab);

        // *** actualizado por cambio de keys ***
        if (selected === "maestrosIndex") {
            return checkPerm('26', async () => navigate('/maestros', newTab));
        }

        if (selected === "geocerca") return GetKeyApp("Geocerca");
        if (selected === "inventarios") return GetKeyApp("Inventario");

        if (selected === "contratosValitronics") return setModalValitronics(true);
        if (selected === "contratosDispositivos") return setModalDispositivos(true);
        if (selected === "uploadFiles") return setModalOpenUploadFiles(true);

        if (selected === "movimientos_usuario") {
            return checkPerm('28', async () => navigate('/movimientos_usuario', newTab));
        }

        if (selected === "generarContrato") {
            return checkPerm('25', async () => setModalOpenGerarContrato(true));
        }

        if (selected === "correccionFechas") {
            setCorreccionFechasModalSize('sm');
            return checkPerm('55', async () => setIsDialogOpenCorreccionFechas(true));
        }

        if (selected === "trackingTiempoReal") {
            return checkPerm('56', async () => setIsDialogOpenTrackingTiempoReal(true));
        }

        if (selected === "modificaciones") {
            return checkPerm('57', async () => setIsDialogOpenModificaciones(true));
        }

        if (selected === "correccionSolicitud") {
            return checkPerm('58', async () => setIsDialogOpenCorreccionSolicitud(true));
        }

        if (selected === "cambioProyecto") {
            return checkPerm('24', async () => setModalCambioProyecto(true));
        }

        if (selected === "transportadoraCreate") return setIsDialogOpenModalTransportadora(true);
        if (selected === "instaladorCreate") return setIsDialogOpenModalInstaladores(true);
        if (selected === "rutaCreate") return setIsDialogOpenModalRutas(true);
        if (selected === "acompananteCreate") return setIsDialogOpenModalAcompanantes(true);

        if (selected === "equiposAct") {
            return checkPerm('23', async () => navigate('/trafico_oculto', newTab));
        }

        if (selected === "downloadMultipleReports") {
            return checkPerm('29', async () => setModalDowloadMultipleFiles(true));
        }

        if (selected === "reporteAjustado") {
            return checkPerm('12', async () => setIsDialogOpenRServicioAjustado(true));
        }
        if (selected === "maestrosTransportadoras") {
            return checkPerm('30', async () => setIsDialogOpenModalTransportadora(true));
        }
        if (selected === "maestrosEmpresas") {
            return checkPerm('63', async () => navigate('/empresas', newTab));
        }
        if (selected === "clientesNegociaciones") {
            return checkPerm('63', async () => navigate('/empresas', newTab));
        }
        if (selected === "maestrosAdminGrupos") {
            return checkPerm('32', async () => setIsDialogOpenModalAdminGrupos(true));
        }
        if (selected === "maestrosInstaladores") {
            return checkPerm('33', async () => setIsDialogOpenModalInstaladores(true));
        }
        if (selected === "maestrosAcompanantes") {
            return checkPerm('34', async () => setIsDialogOpenModalAcompanantes(true));
        }
        if (selected === "maestrosAlertas") {
            return checkPerm('35', async () => setIsDialogOpenModalAlertas(true));
        }
        if (selected === "maestrosRutas") {
            return checkPerm('31', async () => setIsDialogOpenModalRutas(true));
        }
        if (selected === "maestrosCiudades") {
            return checkPerm('36', async () => setIsDialogOpenCiudades(true));
        }
        if (selected === "maestrosAgencias") {
            return checkPerm('37', async () => setIsDialogOpenModalAgencias(true));
        }
        if (selected === "maestrosPropietarios") {
            return checkPerm('50', async () => setIsDialogOpenModalPropietarios(true));
        }
        if (selected === "maestrosVehiculos") {
            return checkPerm('51', async () => setIsDialogOpenModalVehiculos(true));
        }
        if (selected === "reportesBI") {
            return checkPerm('52', async () => setModalReportesBI(true));
        }

        if (selected === "maestrosdispositivos") {
            return checkPerm('53', async () => setIsDialogOpenModalDispositivos(true));
        }
        if (selected === "maestrosUsuariosStreaming") {
            return checkPerm('54', async () => setIsDialogOpenModalUsuariosStreaming(true));
        }
        if (selected === "maestrosbeacons") {
            return checkPerm('60', async () => setIsDialogOpenModalBeacons(true));
        }
    };

    // ========= Clic medio (nueva pestaña) sin romper SideNav =========
    const auxOpen = (key) => (e) => {
        if (e.button === 1) {
            e.preventDefault();
            e.stopPropagation();     // evita que SideNav dispare onSelect
            openByKey(key, true);
        }
    };

    const onCloseModalDowloadMultipleFiles = () => setModalDowloadMultipleFiles(false);

    return (
        <>
            <SideNav
                onSelect={(selected) => {
                    // Si la key está en NEW_TAB_KEYS -> abre en nueva pestaña
                    openByKey(selected, NEW_TAB_KEYS.has(selected));
                }}
            >
                <SideNav.Toggle />
                <SideNav.Nav defaultSelected="trafico">
                    {/* OPERACIONES */}
                    <NavItem eventKey="menuOperaciones">
                        <NavIcon>
                            <i className="bx bxs-truck bx-sm bx-tada-hover"></i>
                        </NavIcon>
                        <NavText>OPERACIONES</NavText>

                        {project && String(project) === "1" && (
                            <NavItem eventKey="solicitudes">
                                <NavText>
                                    <span
                                        onAuxClick={auxOpen("solicitudes")}
                                        style={{ display: "block", cursor: "pointer" }}
                                    >
                                        Solicitudes de Servicios
                                    </span>
                                </NavText>
                            </NavItem>
                        )}

                        {project && String(project) !== "1" && (
                            <NavItem eventKey="contratosValitronics">
                                <NavText>
                                    <span
                                        onAuxClick={auxOpen("contratosValitronics")}
                                        style={{ display: "block", cursor: "pointer" }}
                                    >
                                        Contrato Valitronics
                                    </span>
                                </NavText>
                            </NavItem>
                        )}

                        {project && String(project) !== "1" && (
                            <NavItem eventKey="contratosDispositivos">
                                <NavText>
                                    <span
                                        onAuxClick={auxOpen("contratosDispositivos")}
                                        style={{ display: "block", cursor: "pointer" }}
                                    >
                                        Contrato Dispositivo
                                    </span>
                                </NavText>
                            </NavItem>
                        )}

                        <NavItem eventKey="trafico">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("trafico")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Tráfico en Ruta
                                </span>
                            </NavText>
                        </NavItem>

                        <NavItem eventKey="equiposAct">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("equiposAct")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Equipos activos
                                </span>
                            </NavText>
                        </NavItem>

                        <NavItem eventKey="historico">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("historico")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Servicios Históricos
                                </span>
                            </NavText>
                        </NavItem>

                        <NavItem eventKey="mapcenter">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("mapcenter")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Mapcenter
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="configLives">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("configLives")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Lives
                                </span>
                            </NavText>
                        </NavItem>
                    </NavItem>

                    {/* GEOGRAFÍA */}
                    <NavItem eventKey="menuGeografia">
                        <NavIcon>
                            <i className="bx bxs-map-alt bx-sm bx-tada-hover"></i>
                        </NavIcon>
                        <NavText>GEOGRAFÍA</NavText>

                        <NavItem eventKey="maestrosCiudades">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("maestrosCiudades")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Ciudades
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="maestrosRutas">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("maestrosRutas")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Rutas
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="trayecto">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("trayecto")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Georutas
                                </span>
                            </NavText>
                        </NavItem>
                        {/* <NavItem eventKey="geocerca">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("geocerca")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Geocercas
                                </span>
                            </NavText>
                        </NavItem> */}
                        <NavItem eventKey="geocercas2">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("geocercas2")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Geocercas
                                </span>
                            </NavText>
                        </NavItem>
                    </NavItem>

                    {/* DISPOSITIVOS */}
                    <NavItem eventKey="menuDispositivos">
                        <NavIcon>
                            <i className="bx bxs-devices bx-sm bx-tada-hover"></i>
                        </NavIcon>
                        <NavText>DISPOSITIVOS</NavText>

                        <NavItem eventKey="cambioProyecto">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("cambioProyecto")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Cambio Proyecto
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="control">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("control")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Control Dispositivos
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="traficoPorRecoger">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("traficoPorRecoger")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Equipos por recoger
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="inventarios">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("inventarios")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Inventarios
                                </span>
                            </NavText>
                        </NavItem>
                    </NavItem>
                    {/* Menu Torre de control */}
                    <NavItem eventKey="menuTorreControl">
                        <NavIcon>
                            <i className='bx bx-network-chart bx-sm bx-tada-hover'></i>
                        </NavIcon>
                        <NavText>TORRE DE CONTROL</NavText>
                        <NavItem eventKey="maestrosPropietarios">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("maestrosPropietarios")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Propietarios
                                </span>
                            </NavText>
                        </NavItem>

                        <NavItem eventKey="maestrosVehiculos">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("maestrosVehiculos")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Vehículos
                                </span>
                            </NavText>
                        </NavItem>
                    </NavItem>

                    {/* Pruebaaa */}

                    {/* ADMINISTRACIÓN */}
                    <NavItem eventKey="menuAdministracion">
                        <NavIcon>
                            <i className="bx bxs-briefcase bx-sm bx-tada-hover"></i>
                        </NavIcon>
                        <NavText>ADMINISTRACIÓN</NavText>

                        <NavItem eventKey="clientesNegociaciones">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("clientesNegociaciones")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Clientes y Negociaciones
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="facturacion">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("facturacion")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Facturación
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="carteraClientes">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("carteraClientes")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Cartera Clientes
                                </span>
                            </NavText>
                        </NavItem>
                    </NavItem>

                    {/* REPORTES */}
                    <NavItem eventKey="menuReportes">
                        <NavIcon>
                            <i className="bx bxs-bar-chart-square bx-sm bx-tada-hover"></i>
                        </NavIcon>
                        <NavText>REPORTES</NavText>

                        <NavItem eventKey="reportes">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("reportes")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Business Intelligence
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="reporteGeneral">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("reporteGeneral")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Reporte general
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="reporteVentas">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("reporteVentas")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Reportes OC
                                </span>
                            </NavText>
                        </NavItem>
                    </NavItem>

                    {/* CONFIGURACIÓN */}
                    <NavItem eventKey="menuConfiguracion">
                        <NavIcon>
                            <i className="bx bxs-cog bx-sm bx-tada-hover"></i>
                        </NavIcon>
                        <NavText>CONFIGURACIÓN</NavText>

                        <NavItem eventKey="roles">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("roles")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Roles y Permisos
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="usuarios">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("usuarios")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Usuarios
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="reporteAjustado">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("reporteAjustado")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Reporte Ajustado
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="generarContrato">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("generarContrato")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Reporte Consolidado
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="ediciontrakaphotos">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("ediciontrakaphotos")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Edicion Fotos
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="movimientos_usuario">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("movimientos_usuario")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Movimientos de Usuario
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="downloadMultipleReports">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("downloadMultipleReports")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Descargar Reportes Múltiples
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="correccionFechas">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("correccionFechas")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Corrección fechas
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="trackingTiempoReal">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("trackingTiempoReal")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Tracking tiempo real
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="modificaciones">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("modificaciones")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Modificaciones
                                </span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="correccionSolicitud">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("correccionSolicitud")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Corrección solicitud
                                </span>
                            </NavText>
                        </NavItem>

                        {/* Ejemplo oculto en prod */}
                        {/* <NavItem eventKey="uploadFiles">
                <NavText>
                    <span
                        onAuxClick={auxOpen("uploadFiles")}
                        style={{ display: "block", cursor: "pointer" }}
                    >
                        Upload Archivos
                    </span>
                </NavText>
            </NavItem> */}
                    </NavItem>

                    {/* MAP CENTER ANTIGUO */}
                    {/* <NavItem eventKey="menuMapcenterOld">
                        <NavIcon>
                            <i className="bx bxs-map bx-sm bx-tada-hover"></i>
                        </NavIcon>
                        <NavText>MAP CENTER ANTIGUO</NavText>
                        <NavItem eventKey="mapcenter2">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("mapcenter2")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Map Center
                                </span>
                            </NavText>
                        </NavItem>
                    </NavItem> */}

                    {/* MAESTROS */}
                    <NavItem eventKey="menuMaestros">
                        <NavIcon>
                            <i className="bx bxs-wrench bx-sm bx-tada-hover"></i>
                        </NavIcon>
                        <NavText>MAESTROS</NavText>

                        <NavItem eventKey="reportesBI">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("reportesBI")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Reportes BI
                                </span>
                            </NavText>
                        </NavItem>

                        <NavItem eventKey="maestrosTransportadoras">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("maestrosTransportadoras")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Transportadoras
                                </span>
                            </NavText>
                        </NavItem>

                        <NavItem eventKey="maestrosAdminGrupos">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("maestrosAdminGrupos")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Admin. Grupos
                                </span>
                            </NavText>
                        </NavItem>

                        <NavItem eventKey="maestrosInstaladores">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("maestrosInstaladores")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Instaladores
                                </span>
                            </NavText>
                        </NavItem>

                        <NavItem eventKey="maestrosAcompanantes">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("maestrosAcompanantes")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Acompañantes
                                </span>
                            </NavText>
                        </NavItem>

                        <NavItem eventKey="maestrosAlertas">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("maestrosAlertas")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Alertas
                                </span>
                            </NavText>
                        </NavItem>

                        <NavItem eventKey="maestrosAgencias">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("maestrosAgencias")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Agencias
                                </span>
                            </NavText>
                        </NavItem>

                        <NavItem eventKey="maestrosdispositivos">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("maestrosdispositivos")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Placas GPS
                                </span>
                            </NavText>
                        </NavItem>
                        
                        <NavItem eventKey="maestrosbeacons">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("maestrosbeacons")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Beacons
                                </span>
                            </NavText>
                        </NavItem>

                        <NavItem eventKey="maestrosUsuariosStreaming">
                            <NavText>
                                <span
                                    onAuxClick={auxOpen("maestrosUsuariosStreaming")}
                                    style={{ display: "block", cursor: "pointer" }}
                                >
                                    Usuarios Streaming
                                </span>
                            </NavText>
                        </NavItem>


                    </NavItem>
                </SideNav.Nav>
            </SideNav>


            {/* ===== Modales ===== */}
            < RSeguimientoServicio
                isOpen={isDialogOpenModalInstaladores}
                title={'Creación de instaladores'}
                onClose={onCloseModalInstaladores}
                childComponent={< ModalInstaladores bitInserts={bitInsert} bitEdits={bitEdit} bitDeletes={bitDelete} />}
            />
            < RSeguimientoServicio
                isOpen={isDialogOpenModalTransportadora}
                title={'Creación de transportadora'}
                onClose={onCloseModalTransportadora}
                childComponent={< ModalTransportadoras bitInserts={bitInsert} bitEdits={bitEdit} bitDeletes={bitDelete} />}
            />
            < RSeguimientoServicio
                isOpen={isDialogOpenModalRutas}
                title={'Creación de rutas'}
                onClose={onCloseModalRutas}
                childComponent={< ModalRutas bitInserts={bitInsert} bitEdits={bitEdit} bitDeletes={bitDelete} />}
            />
            < RSeguimientoServicio
                isOpen={isDialogOpenModalDispositivos}
                title={'Creación de Placas GPS'}
                onClose={onCloseModalMaestrosDispositivos}
                childComponent={< ModalDispositivos bitInserts={bitInsert} bitEdits={bitEdit} bitDeletes={bitDelete} />}
            />
            < RSeguimientoServicio
                isOpen={isDialogOpenModalBeacons}
                title={'Creación de Beacons'}
                onClose={onCloseModalMaestrosBeacons}
                childComponent={< ModalBeacons bitInserts={bitInsert} bitEdits={bitEdit} bitDeletes={bitDelete} />}
            />
            < RSeguimientoServicio
                isOpen={isDialogOpenModalUsuariosStreaming}
                title={'Usuarios Streaming'}
                onClose={onCloseModalUsuariosStreaming}
                childComponent={< ModalUsuariosStreaming bitInserts={bitInsert} bitEdits={bitEdit} bitDeletes={bitDelete} />}
            />
            < RSeguimientoServicio
                isOpen={isDialogOpenModalAcompanantes}
                title={'Creación de acompañantes'}
                onClose={onCloseModalAcompanantes}
                childComponent={< ModalAcompanantes bitInserts={bitInsert} bitEdits={bitEdit} bitDeletes={bitDelete} />}
            />
            < RSeguimientoServicio
                isOpen={isDialogOpenModalAdminGrupos}
                title={'Creación de grupos'}
                onClose={onCloseModalAdminGrupos}
                childComponent={< ModalAdminGrupos bitInserts={bitInsert} bitEdits={bitEdit} bitDeletes={bitDelete} />}
            />
            < RSeguimientoServicio
                isOpen={isDialogOpenModalAlertas}
                title={'Creación de alertas'}
                onClose={onCloseModalAlertas}
                childComponent={< ModalAlertas isOpen={isDialogOpenModalAlertas} bitInserts={bitInsert} bitEdits={bitEdit} bitDeletes={bitDelete} />}
            />

            < RSeguimientoServicio
                isOpen={isDialogOpenModalPropietarios}
                title={'Creación de propietarios'}
                onClose={onCloseModalPropietarios}
                childComponent={< ModalPropietarios bitInserts={bitInsert} bitEdits={bitEdit} bitDeletes={bitDelete} />}
            />
            < RSeguimientoServicio
                isOpen={isDialogOpenModalVehiculos}
                title={'Creación de vehículos'}
                onClose={onCloseModalVehiculos}
                childComponent={< ModalVehiculos bitInserts={bitInsert} bitEdits={bitEdit} bitDeletes={bitDelete} />}
            />
            < RSeguimientoServicio
                isOpen={isDialogOpenCiudades}
                title={'Creación de ciudades'}
                onClose={onCloseModalCiudades}
                childComponent={< ModalCiudades bitInserts={bitInsert} bitEdits={bitEdit} bitDeletes={bitDelete} />}
            />
            < RSeguimientoServicio
                isOpen={isDialogOpenModalAgencias}
                title={'Creación de agencias'}
                onClose={onCloseModalAgencias}
                childComponent={< ModalAgencias bitInserts={bitInsert} bitEdits={bitEdit} bitDeletes={bitDelete} />}
            />


            < ModalReporteConsolidadoAjustado
                isOpen={modalOpenGenerarContrato}
                title={'Reporte consolidado'}
                onClose={onCLoseModalOpenGnenerarContrato}
                childComponent={
                    < FormStaticsMapsContrato
                        contratoGlobal={infoContrato[0]}
                        handleContrato={(value) => handleContrato(value)}
                        onSubmit={handleSubmitAndOpenReporteAjustado}
                    />
                }
            />

            <ModalReporteConsolidadoAjustado
                isOpen={isDialogOpenCorreccionFechas}
                title={'Corrección fechas'}
                size={correccionFechasModalSize}
                onClose={() => setIsDialogOpenCorreccionFechas(false)}
                childComponent={
                    <ModalCorreccionFechas
                        isOpen={isDialogOpenCorreccionFechas}
                        onClose={() => setIsDialogOpenCorreccionFechas(false)}
                        onSizeChange={setCorreccionFechasModalSize}
                    />
                }
            />

            <ModalReporteConsolidadoAjustado
                isOpen={isDialogOpenTrackingTiempoReal}
                title={'Tracking tiempo real'}
                size={'sm'}
                onClose={onCloseTrackingTiempoReal}
                childComponent={
                    <ModalTrackingTiempoReal
                        isOpen={isDialogOpenTrackingTiempoReal}
                        onClose={onCloseTrackingTiempoReal}
                        onOpenTracking={openTrackingTiempoRealByContract}
                    />
                }
            />

            <ModalBaseSm
                isOpen={isDialogOpenModificaciones}
                title={'Modificaciones'}
                className="modifications-modal"
                onClose={() => setIsDialogOpenModificaciones(false)}
                childComponent={<ModalModificaciones isOpen={isDialogOpenModificaciones} />}
            />

            <ModalBaseLg
                isOpen={isDialogOpenCorreccionSolicitud}
                title={'Corrección solicitud'}
                onClose={() => setIsDialogOpenCorreccionSolicitud(false)}
                childComponent={<ModalCorreccionSolicitud />}
            />

            < ModalBaseSm
                isOpen={modalCambioProyecto}
                title={'Cambio de proyecto dispositivos'}
                onClose={onCLoseModalCambioProyecto}
                childComponent={< CambioProyecto onClose={onCLoseModalCambioProyecto} bitEdit={bitEdit} />}
            />
            {/* Modal Reportes BI */}

            <ModalBaseLg
                isOpen={modalReportesBI}
                title={'Reportes BI'}
                onClose={() => setModalReportesBI(false)}
                childComponent={< ModalReportesBI onClose={() => setModalReportesBI(false)} bitInsert={bitInsert} bitEdit={bitEdit} bitDelete={bitDelete} />}
            />

            < ModalReporteConsolidadoAjustado
                isOpen={isDialogOpenRServicioAjustado}
                title={'Reporte consolidado ajustado'}
                onClose={onCloseReporteServicioAjustado}
                childComponent={
                    < FormStaticsMapsRecorrido
                        handleContrato={(value) => handleContrato(value)}
                        handleUltPunto={(value) => handleUltPunto(value)}
                        handleUltRecorrido={(value) => handleUltRecorrido(value)}
                        onSubmit={handleSubmitAndOpenReporteAjustado}
                    />
                }
            />

            < ModalReporteServicio
                isOpen={isDialogOpenModalReporteServicio}
                onClose={onCloseModalReporteServicio}
                childComponent={
                    < ReporteServicio
                        contrato={infoContrato[0]}
                        ultPunto={ultPunto}
                        contractR={contractR}
                    />
                }
            />
            < ModalBaseSm
                isOpen={modalDowloadMultipleFiles}
                onClose={onCloseModalDowloadMultipleFiles}
                title={'Multiples reportes de servicio'}
                childComponent={< BuscarContratoYReporte onClose={onCloseModalDowloadMultipleFiles} />}
            />

            <ModalBaseLg
                isOpen={modalReporteVentas}
                onClose={() => {
                    setModalReporteVentas(false);
                    setIsReporteVentasExpanded(false);
                    setReporteVentasSession((session) => session + 1);
                }}
                title={'Reportes OC'}
                size={isReporteVentasExpanded ? 'xl' : 'lg'}
                className={isReporteVentasExpanded ? 'reporte-ventas-modal reporte-ventas-modal--expanded' : 'reporte-ventas-modal'}
                childComponent={<FormReporteVentas key={reporteVentasSession} onSearchStart={() => setIsReporteVentasExpanded(true)} />}
            />

            < ModalBaseSm
                isOpen={modalvalitronics}
                onClose={onCloseModalValitronics}
                title={'Creación de Contratos Valitronics'}
                childComponent={< Valitronics onClose={onCloseModalValitronics} />}
            />
            < ModalBaseSm
                isOpen={modaldispositivos}
                onClose={onCloseModalDispositivos}
                title={'Creación de Contratos Dispositivos'}
                childComponent={< CrearContrato3 onClose={onCloseModalDispositivos} />}
            />
            < ModalBaseLg
                isOpen={modalOpenUploadFiles}
                onClose={onCloseModalUploadFiles}
                title={'Carga de archivos'}
                childComponent={< ModalCreatePlantilla onClose={onCloseModalUploadFiles} />}
            />


            <BaseModalXXL
                isOpen={modalMapCenter}
                title={'MAP CENTER'}
                onClose={cerrarModalMapCenter}
                loading={modalLoading}
            >
                <MapCenter />
            </BaseModalXXL>

            <BaseModalXXL
                isOpen={isDialogOpenTrackingMultimedia}
                title={''}
                onClose={() => {
                    setIsDialogOpenTrackingMultimedia(false);
                    setTrackingMultimediaHubTab(multimediaHubTabs.PHOTOS);
                }}
            >
                <ModalMultimediaHub
                    contratoData={trackingDataGlobal}
                    selectedContrato={trackingSelectedContractID}
                    infoContrato={trackingInfoContratoContainer}
                    initialTab={trackingMultimediaHubTab}
                    onSelectTab={(tab) => setTrackingMultimediaHubTab(tab)}
                    onOpenUploadPhoto={() => { }}
                    onOpenUploadVideo={() => { }}
                    onOpenTracking={() => {
                        setIsDialogOpenTrackingMultimedia(false);
                        setIsDialogOpenTrackingTiempoRealViewer(true);
                    }}
                    onOpenMonitoreo={() => {
                        setIsDialogOpenTrackingMultimedia(false);
                        openTrackingMonitoreo();
                    }}
                    onOpenConsolidado={() => {
                        setIsDialogOpenTrackingMultimedia(false);
                        openTrackingConsolidado();
                    }}
                />
            </BaseModalXXL>

            <ModalBaseLg
                isOpen={isDialogOpenTrackingValitronics}
                title={''}
                onClose={() => setIsDialogOpenTrackingValitronics(false)}
                childComponent={<ModalComprobanteValitronics listComprobantes={trackingListComprobantes} />}
            />

            <BaseModalAuto
                size={'xl'}
                isOpen={isDialogOpenTrackingCheckList}
                title={''}
                onClose={() => setIsDialogOpenTrackingCheckList(false)}
                childComponent={<PrintComponent data={trackingDataGlobal} />}
            />

            <RSeguimientoServicio
                isOpen={isDialogOpenTrackingMonitoreo}
                title={'Monitoreo de tráfico'}
                onClose={() => setIsDialogOpenTrackingMonitoreo(false)}
                childComponent={
                    <FormReporteServicio
                        contrato={trackingSelectedContractID}
                        images={() => {
                            setIsDialogOpenTrackingMonitoreo(false);
                            openTrackingImages();
                        }}
                        tracking={() => {
                            setIsDialogOpenTrackingMonitoreo(false);
                            setIsDialogOpenTrackingTiempoRealViewer(true);
                        }}
                        consolidado={() => {
                            setIsDialogOpenTrackingMonitoreo(false);
                            openTrackingConsolidado();
                        }}
                    />
                }
            />

            {isDialogOpenTrackingAsignacion && (
                <>
                    <div
                        className="modal fade show"
                        id="ModalAsignacion"
                        tabIndex="-1"
                        aria-modal="true"
                        role="dialog"
                        style={{ display: 'block' }}
                    >
                        <ModalAsignacion
                            contratoseleccionado={trackingSelectedContractID}
                            listRutas={trackingListRutas}
                            onClose={handleTrackingAsignacionClose}
                            onUpdateContract={handleTrackingAsignacionUpdate}
                        />
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </>
            )}

            <BaseModalXXL
                isOpen={isDialogOpenTrackingTiempoRealViewer}
                title={'Contrato Seguimiento'}
                onClose={onCloseTrackingTiempoRealViewer}
            >
                {trackingTiempoRealInfo ? (
                    <ReporteContrato
                        isOpen={isDialogOpenTrackingTiempoRealViewer}
                        onClose={onCloseTrackingTiempoRealViewer}
                        contratoVar={trackingTiempoRealInfo}
                        aleatorio={Math.floor(Math.random() * 1000) + 1}
                        images={openTrackingImages}
                        monitoreo={openTrackingMonitoreo}
                        consolidado={openTrackingConsolidado}
                        videos={openTrackingVideos}
                        streaming={openTrackingStreaming}
                        valitronics={openTrackingValitronics}
                        checkList={openTrackingCheckList}
                        trayecto={openTrackingAsignacion}
                        rutaseleccionadaprop={trackingRutaSeleccionada}
                    />
                ) : null}
            </BaseModalXXL>

        </>
    );
};

export default Menu;
